import React from 'react'
import { Select, AutoComplete } from 'antd'
import { getEtlSearch } from '../../../api'
import './index.less'
const { Option } = Select
export interface TitleAssociateProps {
	placeholder: string;
	value?: string;
	onChange?: (value?: string) => void;
}
export interface SearchDataProps {
	text: string;
	tag: string;
}
export interface TitleAssociateState {
	searchData: { value: string }[];
	searchValue: string;
}
class TitleAssociate extends React.Component<TitleAssociateProps, TitleAssociateState> {
	state: TitleAssociateState = {
		searchData: [],
		searchValue: '',
	}
	async getSearch(value: string, callback: (result: { value: string }[]) => void) {
		const { code, data } = await getEtlSearch({ is_list: [7], sug: value, page_no: 1, page_size: 10 });
		if (code === 0 && data && Array.isArray(data.wa)) {
			const result = data.wa.map((item: SearchDataProps) => ({ value: item.text }));
			callback(result);
		} else {
			callback([]);
		}
	}
	// handleSearch(value) {
	// 	if(value) {
	// 		this.getSearch(value, data => this.setState({ searchData: data }))
	// 	} else {
	// 		this.setState({searchData: []})
	// 	}
	// }
	handleChange(value: string) {
		const { onChange } = this.props
		onChange && onChange(value)
	}
	changeValue(value: string) {
		this.handleChange(value)
		this.getSearch(value, data => this.setState({ searchData: data }))
	}
	render() {
		const { searchData } = this.state
		const { placeholder, value } = this.props
		// const options = searchData.map(item => <Option key={item.text} value={item.text}>{item.text}</Option>)
		return (
			// <Select
			// 	value={value}
			// 	showSearch
			// 	placeholder={placeholder}
			// 	defaultActiveFirstOption={false}
			// 	showArrow={false}
			// 	filterOption={false}
			// 	onSearch={this.handleSearch.bind(this)}
			// 	onChange={this.handleChange.bind(this)}
			// 	notFoundContent={null}
			// >
			// 	{options}
			// </Select>
			<AutoComplete
				value={value}
				onChange={this.changeValue.bind(this)}
				options={searchData}
				placeholder={placeholder}
			/>
		)
	}
}

export default TitleAssociate
